<div class="checkbox weaveCheckbox" [ngClass]="classList">
  <mat-checkbox
    [id]="id"
    [checked]="data"
    (change)="toggleCheckbox()"
    tabindex="0"
    [value]="value"
    [disabled]="disabled"
  >
    @if(showLabel) {
    {{label}}
    }
  </mat-checkbox>
</div>
